import EventEmitter from "eventemitter3";
import feathers from "@feathersjs/client";
import { SOCKETHOST } from "./config";

import { getToken } from "./authProvider";
import { getAuthEvents } from "./lib/authEvents";

let client = null;
let socket = null;
let connectionInProgress = false;

const onCreateSocket = new EventEmitter();

const pushMessages = ["kiosksUpdate"];

export const addCreateSubscription = handler => {
  onCreateSocket.on("created", handler);
};

export const removeCreateSubscription = handler => {
  onCreateSocket.removeListener("created", handler);
};

export const initializeClient = apiUrl => {
  client = feathers().configure(
    feathers.rest(apiUrl).fetch(window.fetch.bind(window))
  );
};

export const getClient = () => {
  return client;
};

export const closeSocket = () => {
  if (socket) {
    socket.finished = true;
  }

  if (socket && socket.readyState < 2) socket.close();
};

getAuthEvents().on("logout", () => closeSocket());

const createSocket = () => {
  return new Promise((resolve, reject) => {
    if (socket && socket.readyState === 1 && socket.authenticated) {
      resolve(socket);
    }

    connectionInProgress = true;

    const token = getToken();
    if (!token) {
      console.warn("Not creating socket connection. No user");
      reject();
      return;
    }
    const timeout = setTimeout(() => {
      console.error("Connecting to websocket timed out");
      connectionInProgress = false;
      reject();
    }, 5000);

    socket = new WebSocket(SOCKETHOST);
    socket.authenticated = false;
    const onErrorEventHandler = event => {
      console.error("Error in web socket connection.", event);
      reject();
    };

    const authGrantedHandler = event => {
      let message;
      try {
        message = JSON.parse(event.data);
      } catch (e) {
        console.error("Invalid ws message", event);
        return;
      }

      if (pushMessages.includes(message)) {
        // ignore push messages
        return;
      }

      clearTimeout(timeout);
      connectionInProgress = false;

      socket.removeEventListener("message", authGrantedHandler);
      socket.removeEventListener("error", onErrorEventHandler);

      if (message.type === "auth_ack" && message.status === "ok") {
        console.log("Socket connected");
        onCreateSocket.emit("created", socket);
        socket.authenticated = true;
        resolve(socket);
      } else if (message.type === "auth_ack" && message.status !== "ok") {
        console.error("Websocket auth failed", message);
        closeSocket();
        reject();
      } else {
        console.error("Unknown auth ack message received", message);
        closeSocket();
        reject();
      }
    };

    socket.addEventListener("error", onErrorEventHandler);
    socket.addEventListener("message", authGrantedHandler);

    socket.onopen = () => {
      socket.send(
        JSON.stringify({
          type: "auth",
          token,
        })
      );
    };

    socket.onclose = () => {
      console.log("Socket was closed");
      connectionInProgress = false;

      if (socket.finished) {
        console.log("Finished with socket");
      } else {
        setTimeout(() => {
          createSocket().catch(e =>
            console.log("Socket connection refail.", e)
          );
        }, 3000);
      }
    };
  });
};

export const getSocketClient = () => {
  if (!socket || socket.readyState > 1) {
    return createSocket();
  }

  if (connectionInProgress && !socket.authenticated) {
    return new Promise(resolve =>
      onCreateSocket.once("created", s => resolve(s))
    );
  }

  return Promise.resolve(socket);
};



// WEBPACK FOOTER //
// ./src/serverClient.js